import { PanelType, Stack } from '@fluentui/react';
import { ChoiceGroup } from 'office-ui-fabric-react';
import React, { Component } from 'react';
import Scriba from 'react-scriba';
import { DataDocument } from '../../data/DataDocument.jsx';
import { Immocom } from '../../specifique/immocom';
import { ComboBoxAgence } from '../ComboBox/ComboBoxAgence.jsx';
import { ComboBoxOperation } from '../ComboBox/ComboBoxOperation.jsx';
import { ComboBoxRegion } from '../ComboBox/ComboBoxRegion.jsx';
import { ComboBoxReservation } from '../ComboBox/ComboBoxReservation.jsx';
import { EUIComboBox } from '../EUI/EUIComboBox.jsx';
import { EUINumericField } from '../EUI/EUINumericField.jsx';
import { EUIPanel } from '../EUI/EUIPanel.jsx';
import { EUISeparator } from '../EUI/EUISeparator.jsx';
import { EUITextField } from '../EUI/EUITextField.jsx';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';
import { Upload } from '../Outils/Upload.jsx';

export class FichePublipostage extends Component {

    static defaultProps = {
        isOpen: false,
        /* --- */
        onDismiss: () => null,
    };

    static defaultState = {
        choice: 0,
        fileData: undefined,
        fileName: undefined,
        idAgence: undefined,
        idOperation: undefined,
        idRegion: undefined,
        idReservation: undefined,
        onActiveBoutonEnregistrer: false,
        preset: undefined,
        where: undefined,
    };

    constructor(props) {
        super(props);
        this.state = { ...FichePublipostage.defaultState };
        this.deferredValidation = window.setTimeout(null);
    };

    _onChangeChoice = (key) => {
        this.setState(prevState => {
            const { fileData, fileName } = prevState;
            return { ...FichePublipostage.defaultState, fileData, fileName, choice: key };
        }, this._onVerificationFormulaire);
    };

    _onChangePerimetre = (key, value) => {
        let state = { [key]: value, onActiveBoutonEnregistrer: false };
        switch (key) {
            case "idRegion": state.idAgence = 0;
            case "idAgence": state.idOperation = 0;
            default: break;
        }
        this.setState(state, this._onVerificationFormulaire);
    };

    _onOpen = () => {
        this.setState({ ...FichePublipostage.defaultState });
    };

    _onValidate = () => {
        const { fileData, fileName, idOperation, idReservation, where } = this.state;
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Publipostage en cours..."
        });
        DataDocument._onPublipostageTest(fileData, fileName, idOperation, idReservation, where)
            .then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    const document = responseFetch.reponseAPIobjet || {};
                    const fichier = Scriba.fichier().Base64VersByteArray(document.fileData || []);
                    Scriba.fichier().EnregisterSous(fichier, document.nom);
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, {});
                }
                else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
            });
    };

    _onUpload = (event) => {
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.addEventListener('load', () => {
            this.setState({
                fileData: Scriba.fichier().ByteArrayVersBase64(reader.result),
                fileName: file.name
            }, this._onVerificationFormulaire);
        })
        reader.readAsArrayBuffer(file);
    };

    _onVerificationFormulaire = () => {
        const { fileData, idOperation, idReservation, where } = this.state;
        const onActiveBoutonEnregistrer = !!fileData && ((!!idOperation && !!idReservation) || !!where);
        this.setState({ onActiveBoutonEnregistrer });
    };

    render = () => {

        const { isOpen, onDismiss } = this.props;
        const { choice, idAgence, idOperation, idRegion, idReservation, onActiveBoutonEnregistrer, preset, where } = this.state;

        return <EUIPanel
            headerText="Publipostage ~ Test"
            isFormValid={onActiveBoutonEnregistrer}
            isOpen={isOpen}
            onDismiss={onDismiss}
            onOpen={this._onOpen}
            onValidate={this._onValidate}
            type={PanelType.medium}
        >

            <MessageBars
                errorMessage={this.state.errorMessage}
                warningMessage={this.state.warningMessage}
                onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
            />

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <Upload
                label="Sélectionnez un document de test"
                onChange={event => this._onUpload(event)}
            />

            <ChoiceGroup
                options={[
                    { key: 0, text: "Sélection", },
                    { key: 1, text: "Saisie directe" },
                    { key: 2, text: "Requête SQL" }
                ]}
                label="Méthode de sélection d'une réservation"
                onChange={(event, option) => this._onChangeChoice(option.key)}
                required
                selectedKey={choice}
            />

            <EUISeparator />

            <ComboBoxRegion
                disabled={choice !== 0}
                onChange={(event, option, index, value, item) => this._onChangePerimetre("idRegion", option.key)}
                required={choice === 0}
                selectedKey={idRegion}
            />

            <ComboBoxAgence
                disabled={choice !== 0}
                idRegion={idRegion}
                onChange={(event, option, index, value, item) => this._onChangePerimetre("idAgence", option.key)}
                required={choice === 0}
                selectedKey={idAgence}
            />

            <ComboBoxOperation
                disabled={choice !== 0}
                idAgence={idAgence}
                idRegion={idRegion}
                onChange={(event, option, index, value, item) => this._onChangePerimetre("idOperation", option.key)}
                perimetre="eiffage"
                required={choice === 0}
                selectedKey={idOperation}
            />

            <ComboBoxReservation
                disabled={choice !== 0}
                idOperation={idOperation}
                inclureVentesEnBloc={true}
                onChange={(event, option) => this.setState({ idReservation: option.key }, this._onVerificationFormulaire)}
                required={choice === 0}
                selectedKey={idReservation}
            />

            <EUISeparator />

            <Stack horizontal tokens={{ childrenGap: 10 }}>
                <Stack.Item grow={1}>
                    <EUINumericField
                        disabled={choice !== 1}
                        label="IdOperation"
                        min={0}
                        onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                        onDelayedChange={(event, newValue) => this.setState({ idOperation: newValue }, this._onVerificationFormulaire)}
                        required={choice === 1}
                        value={idOperation}
                    />
                </Stack.Item>
                <Stack.Item grow={1}>
                    <EUINumericField
                        disabled={choice !== 1}
                        label="IdReservation"
                        min={0}
                        onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                        onDelayedChange={(event, newValue) => this.setState({ idReservation: newValue }, this._onVerificationFormulaire)}
                        required={choice === 1}
                        value={idReservation}
                    />
                </Stack.Item>
            </Stack>

            <EUISeparator />

            <EUIComboBox
                disabled={choice !== 2}
                idValeurParDefaut="0"
                label="Preset"
                onChange={(event, option) => this.setState({ preset: option.key, where: option.key }, this._onVerificationFormulaire)}
                options={[
                    { key: "NOT EXISTS (SELECT 1 FROM ReservationDesistee rd WHERE rd.IdOperation = Reservation.IdOperation AND rd.IdReservation = Reservation.IdReservation) ORDER BY NEWID()", text: "Réservation aléatoire non désistée" },
                    { key: "NOT EXISTS (SELECT 1 FROM ReservationDesistee rd WHERE rd.IdOperation = Reservation.IdOperation AND rd.IdReservation = Reservation.IdReservation) AND EXISTS (SELECT 1 FROM Souhait s WHERE s.IdOperation = Reservation.IdOperation AND s.IdReservation = Reservation.IdReservation GROUP BY IdReservation HAVING COUNT(1) = 2) ORDER BY NEWID()", text: "Réservation aléatoire non désistée (2 acquéreurs)" },
                    { key: "NOT EXISTS (SELECT 1 FROM ReservationDesistee rd WHERE rd.IdOperation = Reservation.IdOperation AND rd.IdReservation = Reservation.IdReservation) AND EXISTS (SELECT 1 FROM Souhait s WHERE s.IdOperation = Reservation.IdOperation AND s.IdReservation = Reservation.IdReservation GROUP BY IdReservation HAVING COUNT(1) = 3) ORDER BY NEWID()", text: "Réservation aléatoire non désistée (3 acquéreurs)" },
                ]}
                selectedKey={preset}
            />

            <EUITextField
                disabled={choice !== 2}
                label="SQL"
                multiline
                onChange={(event, newValue) => this.setState({ where: newValue }, this._onVerificationFormulaire)}
                required={choice === 2}
                rows={8}
                value={where}
            />

        </EUIPanel>;
    };

};